// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumUpsellPopover-cls1_0JE","cls2":"PremiumUpsellPopover-cls2_cZe PremiumUpsellPopover-cls1_0JE"};